<template>
  <div>
    <div v-if="isMobile() || isTablet()"><outages-table-mobile /></div>
    <div v-if="!isMobile() && !isTablet()"><outages-table-desktop /></div>
  </div>
</template>

<script>
import vueMqMixin from "../mixins/VueMqMixin";
import OutagesTableMobile from "./OutagesTableMobile";
import OutagesTableDesktop from "./OutagesTableDesktop";

export default {
  name: "OutagesByUtilityAndCounty",
  mixins: [vueMqMixin],
  components: {
    OutagesTableMobile,
    OutagesTableDesktop
  }
};
</script>